import CondominiumOwnerListScreen from './OwnerList';
import CondominiumAssemblyPutScreen from './AssemblyPut';
import CondominiumAssemblyDetailScreen from './AssemblyDetail';
import CondomoniumAssemblySubjectsScreen from './SubjectDetail';
import CondomoniumCommentsScreenScreen from './CommentsScreen';
import CondomoniumPutScreen from './Put';

import withAuth from '../../hocs/withAuth';
import withJanitor from '../../hocs/withJanitor';

const compose = (...fns) =>
  fns.reduceRight(
    (prevFn, nextFn) => (...args) => nextFn(prevFn(...args)),
    value => value,
  );

export default [
  {
    path: '/condominiums/new',
    exact: true,
    component: withAuth(CondomoniumPutScreen),
  },
  {
    path: '/condominiums/:condominiumId/dwellers',
    exact: true,
    component: withAuth(CondominiumOwnerListScreen),
  },
  {
    path: '/condominiums/:condominiumId/:type(assembly|meeting)/register',
    exact: true,
    component: withAuth(CondominiumAssemblyPutScreen),
  },
  {
    path: '/condominiums/:condominiumId/:type(assembly|meeting)/:assemblyId/edit',
    exact: true,
    component: withAuth(CondominiumAssemblyPutScreen),
  },
  {
    path: '/condominiums/:condominiumId/:type(assembly|meeting)/:assemblyId',
    exact: true,
    component: withAuth(CondominiumAssemblyDetailScreen),
  },
  {
    path: '/condominiums/:condominiumId/:type(assembly|meeting)/:assemblyId/:subjectId/comments',
    exact: true,
    component: withAuth(CondomoniumCommentsScreenScreen),
  },
  {
    path: '/condominiums/:condominiumId/:type(assembly|meeting)/:assemblyId/subjects',
    exact: true,
    component: compose(withAuth, withJanitor)(CondomoniumAssemblySubjectsScreen),
  },
];
